import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { activities, companies } from '@/../../db'; 

export default function Profile() {
  const currentActivity = activities
    .filter(activity => !activity.endDate)
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];

  const currentCompany = currentActivity ? companies.find(company => company.id === currentActivity.companyId) : null;

  return (
    <div className="space-y-4 p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex flex-col md:flex-row gap-6 items-center md:items-start justify-center">
          <div className="flex-1 flex justify-center">
            <p className="text-muted-foreground mb-8 text-center">
              "I love to dive into information problems and fix things fast."
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
